import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { HBox, VBox } from '../../../components/Box';
import { BaseComponent } from '../../../components/BaseComponent';
import { FieldError } from '../../../components/FieldError';

const ErrorContainer = styled.div`
  color: red;
`;

const STATE = {};

class BpmEstimateComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  applyEstimateAmount() {
    this.props.apply(this.estimateAmount);
  }

  get errors() {
    return this.props.estimate?.errors;
  }

  get estimateAmount() {
    return this.props.estimate?.result?.amount;
  }

  render() {
    return (
      <VBox>
        {this.renderBpmEstimateResult()}
        {this.renderBpmEstimateErrors()}
      </VBox>
    );
  }

  renderBpmEstimateResult() {
    return (
      this.estimateAmount !== undefined &&
      this.estimateAmount !== null && (
        <HBox>
          <div>
            {this.lbl('vehicle.details.price.estimatedRestBPM')}: {this.estimateAmount}
          </div>
          <div>
            <a onClick={this.applyEstimateAmount.bind(this)}>Apply</a>
          </div>
        </HBox>
      )
    );
  }

  renderBpmEstimateErrors() {
    return (
      this.errors &&
      this.errors.length > 0 && (
        <div>
          <ErrorContainer>
            <p>{this.lbl('vehicle.details.price.bpmEstimate.errorLbl')}</p>
          </ErrorContainer>
          <FieldError errors={this.errors} />
        </div>
      )
    );
  }
}

BpmEstimateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BpmEstimate = compose(
  withConnect,
  withRouter,
)(BpmEstimateComp);
